'use strict';

var React = require('react');

var SvgPinMajor = function SvgPinMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.108 1.31c.407-.232.891-.31 1.387-.31h5.009c.496 0 .98.078 1.387.31.448.257.73.662.82 1.133.083.426-.004.828-.114 1.134a3.769 3.769 0 0 1-.42.814l-.586 1.11a.926.926 0 0 0-.091.28c.001.007.013.05.095.226l1.802 3.685c.254.472.455.91.546 1.301.093.398.121.99-.326 1.463-.375.395-.89.477-1.174.509a9.996 9.996 0 0 1-1.047.035h-2.396v5a1 1 0 1 1-2 0v-5h-2.396c-.355 0-.732 0-1.047-.035-.284-.032-.798-.114-1.172-.508-.449-.472-.42-1.064-.329-1.463.091-.392.292-.83.547-1.302l1.8-3.68c.046-.104.068-.154.084-.198a.258.258 0 0 0 .01-.037.897.897 0 0 0-.089-.276l-.585-1.11a3.771 3.771 0 0 1-.42-.814c-.11-.307-.197-.708-.115-1.134.09-.471.373-.876.82-1.132Z"
  }));
};

exports.SvgPinMajor = SvgPinMajor;
